import React from "react";
import "./roadClosureWorkPermitAll.css";

const Template8CS = ({ clearanceRenewal = [] }) => {
  const totalRows = 4;
  const dataRows = Array.isArray(clearanceRenewal)
    ? clearanceRenewal.slice(0, totalRows)
    : [];
  const emptyRows = Array.from(
    { length: Math.max(totalRows - dataRows.length, 0) },
    () => ({})
  );
  const rows = [...dataRows, ...emptyRows];

  const formatDate = (dateString) => {
    if (!dateString) return "";

    const date = new Date(dateString);
    const day = String(date.getUTCDate()).padStart(2, "0");
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const year = date.getUTCFullYear();

    return `${day}/${month}/${year}`;
  };

  const formatTime = (dateString) => {
    if (!dateString) return "";

    const date = new Date(dateString);
    return date.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
      timeZone: "UTC",
    });
  };

  return (
    <div className="rc_template-container">
      <div className="template-container-content">
        <div className="template-container-header">
          <div className="template-heading">क्लीयरेंस नवीकरण / Clearance renewal</div>
          <div className="cold-remarks"></div>
          <div className="rc-work-table">
            <table className="rc-work-table">
              <colgroup>
                <col style={{ width: "8%" }} />
                <col style={{ width: "7%" }} />
                <col style={{ width: "7%" }} />
                <col style={{ width: "14%" }} />
                <col style={{ width: "22%" }} />
                <col style={{ width: "22%" }} />
                <col style={{ width: "20%" }} />
              </colgroup>
              <thead>
                <tr>
                  <th
                    rowSpan="2"
                    className="permit-template-clearance renewal-permit1"
                  >
                    दिनांक <br /> Date
                  </th>
                  <th colSpan="2" className="permit-template-clearance">
                    समय / Time
                  </th>
                  <th className="permit-template-clearance renewal-permit01">
                    विस्तार <br /> Extension
                  </th>
                  <th
                    rowSpan="2"
                    className="permit-template-clearance renewal-permit2"
                  >
                    जारीकर्ता का नाम, पद और हस्ताक्षर <br />
                    Issuer Name, Designation & Signature
                  </th>
                  <th
                    rowSpan="2"
                    className="permit-template-clearance renewal-permit2"
                  >
                    प्राप्तकर्ता का नाम, पद और हस्ताक्षर <br />
                    Receiver Name, Designation & Signature
                  </th>
                  <th
                    rowSpan="2"
                    className="permit-template-clearance renewal-permit2"
                  >
                    सुरक्षा अधिकारी का नाम और हस्ताक्षर <br />
                    Safety Officer Name & Signature
                  </th>
                </tr>
                <tr>
                  <th className="permit-template-clearance renewal-permit1">
                    से <br /> From
                  </th>
                  <th className="permit-template-clearance renewal-permit1">
                    तक <br /> To
                  </th>
                  <th className="permit-template-clearance">
                    तक बढ़ा दिया गया <br /> Extended up to __ Hrs.
                  </th>
                </tr>
              </thead>
              <tbody>
                {rows.map((row, index) => (
                  <tr className="permit-row-end" key={index}>
                    <td>{formatDate(row.date_from)}</td>
                    <td>{formatTime(row.date_from)}</td>
                    <td>{formatTime(row.date_to)}</td>
                    <td>
                      {row.extended_hours || ""}
                      {row.additional_instruction && (
                        <div className="rc_renewal-instruction">
                          अतिरिक्त सावधानियाँ / Additional precautions: {row.additional_instruction}
                        </div>
                      )}
                    </td>
                    <td>
                      {row.issuer_name
                        ? `${row.issuer_name} (${row.issuer_designation})`
                        : ""}
                    </td>
                    <td>{row.receiver_name || ""}</td>
                    <td>{row.safety_officer_name || ""}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Template8CS;
